import {defaultState} from './default-state';
import {ACTION_TYPES as types} from './action-types';

const reducer = (state = defaultState, action) => {
    let newState = state;
    switch (action.type) {
        case types.SET_SEARCHED_RESULTS:
            newState = {
                ...state,
                lastQuery:action.results.query,
                results: action.results,
            }
            break;
        case types.SET_CATEGORIES:
            newState = {
                ...state,
                categories: action.categories
            }
            break;
    }

    return newState;
}


export default reducer;